import React from "react";
import { Props } from "./types";
import { Report } from "./report";
import styles from "./styles.scss";

function ReportsList({ project, reports, authorFilter, sort }: Props) {
  return (
    <ul className={styles.reportsList}>
      {reports
        .sort((current, next) =>
          sort === "old"
            ? new Date(current.submissionDate) < new Date(next.submissionDate)
              ? -1
              : 1
            : sort === "new"
              ? new Date(current.submissionDate) < new Date(next.submissionDate)
                ? 1
                : -1
              : 0,
        )
        .filter(({ author }) =>
          authorFilter.length > 0
            ? authorFilter.find(({ name }) => name === author)
            : true,
        )
        .map((report) => (
          <li key={report.uuid} className={styles.report}>
            <Report report={report} project={project} />
          </li>
        ))}
    </ul>
  );
}

export { ReportsList };
